import {
  _BaseCssVarProvideProps as BCVPProps,
  _OnlyKeepRecord as OnlyKeepRecord,
  _CssVarManagerInter,
  _GetCssVarManager
} from './type'
import {
  Base,
  Component,
  Prop,
  ProvideReactive,
  Watch
} from '@/vue-property-decorator'
import { getCompCssVarMapper } from './getCompCssVarMapper'
import { merge } from 'lodash'
import { styleAppendCssVar } from '../util/styleAppendCssVar'
import { useMainStore } from '@/store/index'
export type CssVarManagerInter = _CssVarManagerInter
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GetCssVarManager<T extends Record<string, any>> =
  _GetCssVarManager<T>
/** cssVarManager接口
 *  最终方案:
 * 1. cssVarManager 以cssVar为基础进行升级
 * 2. cssVarManager 使用provide进行透传.
 * 3. cssVarManager 会生成一个mapper,子组件通过自己的name作为key进行匹配.每个子项只拿自己的内容
 * 4. 只要有内容,则清空原本的内容,以传入的内容为准.
 * 5. cssVarManagerMust  的优先级会高于cssManager,但它们不会穿透传递,只作用于赋值的那一层.
 */

/** cssVar注入的子类能复用的就仅有一个InjectReactive,感觉没有太大的引入的必要,但是也是可以引入 */
@Component<BaseCssVarProvide>({
  name: 'BaseCssVarProvide'
})
export default class BaseCssVarProvide<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, any> = Record<string, any>
> extends Base<unknown, BCVPProps<T>> {
  /** css变量映射 */
  @Prop() cssVarManager!: BCVPProps<T>['cssVarManager']

  /** 需要由混入类进行具体实现(该类,必须由子项去实现它.) */
  protected baseCssVarManager!: () => GetCssVarManager<T>

  /** 监听页面与h5与web的切换 */
  protected get isWeb() {
    return useMainStore().isWeb
  }

  /** 合并基础配置与自定义配置项 */
  private get localCssVarManager() {
    const baseCss = this.baseCssVarManager?.()
    const customCss = this.cssVarManager?.()
    return merge(baseCss, customCss) as OnlyKeepRecord<T>
  }

  /** 暴露给子组件,子组件通key获得控制自己的那一块样式的内容 */
  @ProvideReactive('compCssVarMapper')
  protected get compCssVarMapper() {
    return getCompCssVarMapper(this.localCssVarManager)
  }

  // 当web与h5尺寸切换时,需要重新计算一下赋值
  @Watch('isWeb')
  /** 绑定cssVar到dom上 */
  private bindCssVarInDom() {
    if (!this.localCssVarManager) {
      return console.error(
        `没有任何样式绑定到 ${this.$options.name} 上,请检查一下!`
      )
    }
    // 将css变量的mapper值注入到dom元素上
    const style = (this.$el as unknown as HTMLElement)?.style
    styleAppendCssVar({
      style,
      cssMap: this.localCssVarManager,
      isRecursive: true
    })
  }

  mounted(): void {
    this.bindCssVarInDom()
  }
}
